export class TransactionValidationErrorResponse {
  identifier: any;
  propertyTransferred: any;
  transferDateYear: any;
  value: any;
  description: any;
  units: any;
  sourceEntity: any;
  legalEntityTransactions: any;
  'legalEntityTransactions[0].entity.entityId': any;
  'legalEntityTransactions[1].entity.entityId': any;
  'partyRole.partyRoleId': any;
  'transactionType.transactionTypeId': any;
}
